import React, { useState } from 'react';
import { translate } from '../translations';
import { getTheme } from '../Theme';

import { ReactComponent as ViewUpIcon } from '../icons/jobs_extendView_up.svg';
import { ReactComponent as ViewDownIcon } from '../icons/jobs_extendView_down.svg';
import { ReactComponent as DownloadIcon } from '../icons/jobs_download.svg';

import doc1 from '../files/ZapytanieOfertowe1.pdf';
import doc2 from '../files/ZapytanieOfertowe2.pdf';
import doc3 from '../files/ZapytanieOfertowe3.pdf';
import doc5 from '../files/ZapytanieOfertowe5.pdf';

import tempImg from '../images/contact_navImg.png';

const jobs = [
  {
    id: 'ZapytanieOfertowe5',
    title: 'Zapytanie ofertowe 5',
    doc: doc5
  }
];

const jobsArchive = [
  {
    id: 'ZapytanieOfertowe3',
    title: 'Zapytanie ofertowe 3',
    doc: doc1
  },
  {
    id: 'ZapytanieOfertowe4',
    title: 'Zapytanie ofertowe 4',
    doc: doc2
  },
  {
    id: 'ZapytanieOfertowe1',
    title: 'Zapytanie ofertowe 1',
    doc: doc3
  }
];

const Jobs = () => {
  return (
    <section id="jobs">
      <img className={getTheme('template-img')} src={tempImg} alt={'test'} />
      <div className='container'>
      <h1 className={getTheme('jobs-header')} >{translate('Aktualne:')}</h1>
        {jobs.map((j) => (
            <JobOffers job={j} key={j} />
          ))}
          </div>
      <div className='container'>
      <h1 className={getTheme('jobs-header')} >{translate('Archiwalne:')}</h1>
        {jobsArchive.map((j) => (
          <JobOffers job={j} key={j} />
        ))}
      </div>
      
    </section>
  );
};

const JobOffers = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const { job } = props;
  let ViewIcon = null;

  if (collapsed) {
    ViewIcon = (
      <ViewUpIcon
        onClick={() => setCollapsed(!collapsed)}
        className={getTheme('icons') + ' jobs-icons' }
      />
    );
  } else {
    ViewIcon = (
      <ViewDownIcon
        onClick={() => setCollapsed(!collapsed)}
        className={getTheme('icons') + ' jobs-icons' }
      />
    );
  }
    return (
      <>


      <div className='jobs-container'>
        <div className='col-inner-center'>
          <div className={getTheme('jobs-content')}>
            <div className='jobs-row'>
              <h2 className='jobs-h2'>{translate(job.title)}</h2>
              <a
                className='jobs-a'
                href={job.doc}
                target='_blank'
                download={job.id}>
                <DownloadIcon className={getTheme('icons') + ' jobs-icons' }/>
              </a>
              {ViewIcon}
            </div>
          </div>
          { collapsed ? 
          
          <iframe
              className={'jobs-iframe'}
              src={job.doc}
              frameborder='0' /> 
           : <></>}
             
        </div>
      </div>
      </>
    );
  }


export default Jobs;
